import axios from 'axios'
import {BASE_URL} from '../../services/ApiService/ApiConfig.js'

export class BitacoraService {

    async consultarPorUsuarioFechaTurno(usuarioId, fecha, turno) {
        let token = localStorage.getItem('jwt');
        if (token) {
            token = token.replaceAll('"', '');
        }
        let config2 = {
            headers: {
                'Content-Type': "application/json",
                'Access-Control-Allow-Origin': '*',
                'Access-Control-Allow-Headers': '*',
                'Authorization': 'Bearer ' + token
            },
            params: {
                fecha: fecha,
                turno: turno
            }
        }
        return await axios.get(`${BASE_URL}/bitacora/${usuarioId}/bitacora`, config2).then(res => res.data);
    }

    async consultarPorUsuarioFechaTurnoLimit(usuarioId, fecha, turno, limit) {
        let token = localStorage.getItem('jwt');
        if (token) {
            token = token.replaceAll('"', '');
        }
        let config2 = {
            headers: {
                'Content-Type': "application/json",
                'Access-Control-Allow-Origin': '*',
                'Access-Control-Allow-Headers': '*',
                'Authorization': 'Bearer ' + token
            },
            params: {
                fecha: fecha,
                turno: turno,
                limit: limit
            }
        }
        return await axios.get(`${BASE_URL}/bitacora/${usuarioId}/bitacora/limit`, config2).then(res => res.data);
    }

    async consultarPorFechaYTurno(fecha, turno) {
        let token = localStorage.getItem('jwt');
        if (token) {
            token = token.replaceAll('"', '');
        }
        let config2 = {
            headers: {
                'Content-Type': "application/json",
                'Access-Control-Allow-Origin': '*',
                'Access-Control-Allow-Headers': '*',
                'Authorization': 'Bearer ' + token
            },
            params: {
                fecha: fecha,
                turno: turno
            }
        }
        return await axios.get(`${BASE_URL}/bitacora/bitacora`, config2).then(res => res.data);
    }

    async guardar(usuarioId, bitacoraDet) {
        let token = localStorage.getItem('jwt');
        if (token) {
            token = token.replaceAll('"', '');
        }
        let config = {
            headers: {
                'Content-Type': "application/json",
                'Access-Control-Allow-Origin': '*',
                'Access-Control-Allow-Headers': '*',
                'Authorization': 'Bearer ' + token
            }
        }
        return await axios.post(`${BASE_URL}/bitacora/${usuarioId}/bitacora`, { data: bitacoraDet }, config).then(res => res.data)
    }

}
